import { Button, Form, Row, Tab, Tabs } from "react-bootstrap";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import moment from 'moment-timezone';
import { Trans, useTranslation } from 'react-i18next';

const Home = () => {
	moment.tz.setDefault("Asia/Ho_Chi_Minh");
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		visit_id: '',
		visit_code: '',
		person_code: '',
		health_contract_code: '',
		appointment_id: '',
		expect_date: null,
		facility_number: '2',
		day_part: '0',		
		facility_assigned: '',
		full_name: '',
		phoneNumber: '',
		email: '',
		organisation_name: '',
		relative_name: '',
		health_contract_name: '',
		out_of_packages: '',
		start_date: new Date(),
		end_date: new Date(new Date().getFullYear(), 12, 31),
		message: '',
	});

	const [healthContractCode, setHealthContractCode] = useState('');
	const [facilityAssigned, setFacilityAssigned] = useState('');
	const [excludeDates, setExcludeDates] = useState([]);
	const [dayPartAvail, setDayPartAvailable] = useState(0);
	
	useEffect(() => {
		const user = localStorage.getItem("user");
		const token = JSON.parse(user).token;
		const headers = { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }

		fetch(
			'https://booking.bernard.vn/api/Appointment/appointments', { headers }
		)
		.then(async response => {
			if(response.ok){
				const isJson = response.headers.get('content-type')?.includes('application/json');
				const data = isJson ? await response.json() : null;
				if (Object.keys(data).length > 0) {
					let fData = data[0];
					if (fData['start_date']) {		
						fData['start_date'] = new Date(Date.parse(fData['start_date']));						
					}
					else {
						let currentDate = new Date();		
						currentDate.setDate(currentDate.getDate() + 3);
						fData['start_date'] = currentDate;
					}

					if (!fData['expect_date']) {						
						fData['expect_date'] = fData['start_date'];
					}
					else {
						fData['expect_date'] = new Date(Date.parse(fData['expect_date']));
					}

					if (fData['end_date']) {
						fData['end_date'] = new Date(Date.parse(fData['end_date']));
					}

					if(!fData['date_of_birth']){
						fData['date_of_birth'] = new Date(Date.parse(fData['date_of_birth']));
					}

					if (!fData['facility_number']) {
						fData['facility_number'] = '2';
					}
					else {
						fData['facility_number'] = fData['facility_number'].toString();
					}

					if (!fData['day_part']) {
						fData['day_part'] = '1';
					}
					else {
						fData['day_part'] = fData['day_part'].toString();
					}
	
					if(fData['relative_name']){
						fData['relative_name'] = fData['relative_name'].toString();
					}
					else {
						fData['relative_name'] = '';
					}
					
					if(fData['out_of_packages']){
						fData['out_of_packages'] = fData['out_of_packages'].toString();
					}
					else{
						fData['out_of_packages'] = '';
					}

					setFormData(fData);

					setHealthContractCode(fData['health_contract_code']);
					setFacilityAssigned(fData['facility_assigned'].toString());					
				}
			}
			else if(response.status === 401){
				navigate('/signin', { replace: true });
			}
		})
		.catch(error => {
			if (error === 401) {
				navigate('/signin', { replace: true });
			}
		});

	}, [navigate]);

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });		
	};

	useEffect(() => {
		updateExcludeDates();		
	},[formData.facility_number]);

	useEffect(() => {
		if(excludeDates && excludeDates.length > 0 && formData.expect_date)
		{
			if(excludeDates.some((x) => x.toISOString() === formData.expect_date.toISOString())){
				setFormData({...formData, 'expect_date': ''});				
			}
		}		
	}, [excludeDates]);

	useEffect(() => {
		//Check date-part available
		if(formData.expect_date && formData.expect_date !== ''){
			const user = localStorage.getItem("user");
			const person_code = JSON.parse(user).person_code;
			var date = moment(formData.expect_date).format('yyyy-MM-DD');			
			let url = `https://booking.bernard.vn/api/Facility/datePartAvailable?facility_number=${formData.facility_number}&date=${date}&person_code=${person_code}`;
			fetch(url)
			.then(async response => {
				if(response.ok){
					let dayPartAvail = await response.text();					
					setDayPartAvailable(dayPartAvail);
					if(dayPartAvail === '1' || dayPartAvail === '2'){
						setFormData({ ...formData, 'day_part': dayPartAvail });					
					}
				}
			});
		}		
	}, [formData.expect_date, formData.facility_number]);

	const bookingDateChanged = (date) => {
		setFormData({ ...formData, 'expect_date': date });		
	}

	const updateExcludeDates = () => {		
		const user = localStorage.getItem("user");
		const person_code = JSON.parse(user).person_code;

		fetch(			
			'https://booking.bernard.vn/api/Facility/fullSlotDays?facility_number=' + formData.facility_number  + '&person_code=' + person_code
		)
		.then(async response => {
			if(response.ok){
				const isJson = response.headers.get('content-type')?.includes('application/json');
				const data = isJson ? await response.json() : null;

				var result = [];
				data.forEach(d => {
					result.push(new Date(d));			
				});		
				setExcludeDates(result);
			}
		});
	}

	const bookingSubmit = (e) => {
		e.preventDefault();
		const user = localStorage.getItem("user");
		const token = JSON.parse(user).token;
		
		let data = {...formData};
		data['expect_date'] = moment(data.expect_date).format('yyyy-MM-DD');
		
		const headers = { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
		fetch('https://booking.bernard.vn/api/Appointment/updateAppointment', { method: "POST", headers, body: JSON.stringify(data) })		
			.then(response => {
				if (response.ok) {
					response.json().then(data => {
						navigate('/thankyou', { state: { facility_number: formData.facility_number, message: data.message, day_part: formData.day_part, expect_date: formData.expect_date }, replace: true });
					})
				}
				else {
					handleShowErrorModal();
				}
			}); 
	}

	const isWeekday = (date) => {
		const day = date.getDay();
		return day !== 0;
	};

	const [showErrorModal, setShowErrorModal] = useState(false);
	const handleCloseErrorModal = () => {
		setShowErrorModal(false);
	}

	const handleShowErrorModal = () => {
		setShowErrorModal(true);
	}

	return (		
		<div className="content-wrappter">
			<Modal centered show={showErrorModal} onHide={handleCloseErrorModal} animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>{t('booking_fail')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Trans i18nKey="booking_fail_message">
                        <Link to="tel:+842835352468"></Link>
                        <Link to="tel:+84911072200"></Link>
                    </Trans>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={handleCloseErrorModal}>
						{t('close')}
					</Button>
				</Modal.Footer>
			</Modal>			
			<h1 className="title page-title">{t('health_checkup')}</h1>
			<Tabs defaultActiveKey="dang-ky" id="tab-pages" className="mb-3">
				<Tab eventKey="dang-ky" title={t('health_check_tab')}>
					<Form onSubmit={bookingSubmit}>
						<Row>
							<div className="col-lg-6 user-info">
								<div className="form-title" >{t('customer_info')}</div>
								<div className="form-content">
								<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }}>{t('full_name')}</Form.Label>
										<Form.Control name="full_name" disabled type="text" value={formData.full_name} />
									</Form.Group>
								<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }}>PID</Form.Label>
										<Form.Control name="person_code" disabled type="text" value={formData.person_code}/>
									</Form.Group>
								</div>
								<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }}>{t('phonenumber')}</Form.Label>
										<Form.Control name="phoneNumber" type="text" value={formData.phoneNumber} onChange={handleChange}  />
									</Form.Group>
									<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }}>Email</Form.Label>
										<Form.Control name="email" type="email" value={formData.email} onChange={handleChange}  />
									</Form.Group>
									<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }}>{t('company_name')}</Form.Label>
										<Form.Control name="organisation_name" disabled type="text" value={formData.organisation_name} />
									</Form.Group>									
									<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }}>{t('contract_code')}</Form.Label>
										<Form.Control name="healthContractCode" disabled type="text" value={healthContractCode}/>
									</Form.Group>
							</div>
							<div className="col-lg-6 appointment-booking">
								<div className="form-title" >{t('make_appointment')}</div>
								<div className="form-content">
									<div className="row">
										<div className="col-md-6 col-xs-12">
											{t('working_hour')} <b />
											<ul>
												<li>{t('working_morning')}</li>
												<li>{t('working_afternoon')}</li>
											</ul>

										</div>
										<div className="col-md-6 col-xs-12">
											{t('registration_hour')}<b />
											<ul>
												<li>{t('registration_morning')}</li>
												<li>{t('registration_afternoon')}</li>
											</ul>
										</div>	
									</div>								
									<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }} >{t('choose_clinic')}</Form.Label>
										<Form.Check name='facility_number' disabled={facilityAssigned === '2'} checked={(formData.facility_number === '1' && facilityAssigned !=='2') || facilityAssigned==='1' } type='radio' label={t('bernard_1')} value='1' onChange={handleChange} />
										<Form.Check name='facility_number' disabled={facilityAssigned === '1'} checked={(formData.facility_number === '2' && facilityAssigned !=='1') || facilityAssigned==='2'} type='radio' label={t('bernard_2')} value='2' onChange={handleChange} />
									</Form.Group>

									<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }}>{t('booking_date')}</Form.Label>										
										<div>
											<DatePicker className="form-control" name="expect_date" excludeDates={excludeDates} filterDate={isWeekday} dateFormat="dd/MM/yyyy" minDate={formData.start_date} onChange={bookingDateChanged} selected={formData.expect_date} value={formData.expect_date} maxDate={formData.end_date} />
										</div>
									</Form.Group>

									<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }}>{t('times_of_day')}</Form.Label>										
										<div style={{ display: 'flex' }}>
											<Form.Check name='day_part' disabled={dayPartAvail === '2'} checked={formData.day_part === '1'} type='radio' label={t('morning')} value='1' onChange={handleChange} />
											<Form.Check name='day_part' disabled={dayPartAvail === '1'} checked={formData.day_part === '2'} type='radio' label={t('afternoon')} value='2' onChange={handleChange} style={{ marginLeft: 15 + 'px' }} />
										</div>
									</Form.Group>

									<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }}>{t('Người thân đi cùng (nếu có)')}</Form.Label>	
										<div style={{ display: 'flex' }}>
											<Form.Control name="relative_name" multiple={true} type="text" value={formData.relative_name} placeholder="Vui lòng ghi rõ họ tên và số điện thoại liên hệ"  onChange={handleChange}/>
										</div>										
									</Form.Group>

									<Form.Group className="mt-3">
										<Form.Label style={{ fontWeight: 'bold' }}>{t('Đăng ký dịch vụ bổ sung hoặc các yêu cầu khác')}</Form.Label>	
										<div style={{ display: 'flex' }}>
											<Form.Control name="out_of_packages" multiple={true} type="text" value={formData.out_of_packages} onChange={handleChange}/>
										</div>										
									</Form.Group>

									<Form.Group className="mt-3 form-submit-group" style={{ display: 'flex', flexDirection: 'row' }}>
										<Button type='submit' className='submit'>{t('booking_now')}</Button>
									</Form.Group>
								</div>
							</div>
						</Row>
					</Form>

				</Tab>
				<Tab eventKey="profile" title={t('health_check_result')}>
					{t('under_construction')}
				</Tab>
			</Tabs>
		</div>
	)
};

export default Home;